import { OrderTypeConfiguration } from "models/order-management/orderTypeConfiguration";

export const mockConfig: Array<OrderTypeConfiguration> = [
  {
    orderType: "DIAGNOSIS",
    orderTypeDisplayName: "Diagnosis",
    orderTypeSort: 1,
    amendable: true,
    components: [
      {
        componentName: "dropdown",
        componentLabel: "Diagnosis Type",
        properties: [
          {
            name: "diagnosisType",
            label: "Diagnosis Type",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "Primary Diagnosis",
                value: "primary",
                isDefault: true,
              },
            ],
          },
        ],
      },
      {
        componentName: "current-diagnosis",
        componentLabel: "Current Diagnosis",
      },
      {
        componentName: "diagnosis-search",
        componentLabel: "Primary Diagnosis",
        properties: [
          {
            name: "diagnosis",
            label: "Diagnosis",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
                isDefault: true,
              },
            ],
          },
        ],
      },
      {
        componentName: "date-picker",
        componentLabel: "Order Start Date",
        properties: [
          {
            name: "startDate",
            label: "Order Start Date",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "MM/DD/YYYY",
                value: "mm/dd/yyy",
                isDefault: true,
              },
            ],
          },
        ],
      },
      {
        componentName: "ordering-provider",
        componentLabel: "Ordering Provider",
        properties: [
          {
            name: "orderingProviderDisplayName",
            label: "Ordering Provider",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Search Provider",
                value: "searchProvider",
                isDefault: true,
              },
            ],
          },
        ],
      },
      {
        componentName: "text-area",
        componentLabel: "Provider Notes",
        properties: [
          {
            name: "providerNotes",
            label: "Provider Notes",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
                isDefault: true,
              },
            ],
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel:
          "I, hereby attest this order accurately reflects signatures/notations that I made in my capacity as [ProviderName] when I treated/diagnosed the listed patient. I do hereby electronically attest and certify that this information is true, accurate, and appropriate for this order to the best of my knowledge. ",
        properties: [
          {
            name: "eSignVerification",
            label: "eSignVerification",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "radio-group",
        properties: [
          {
            name: "approvalType",
            label: "Provider Order",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Verbal",
                value: "verbal",
              },
              {
                label: "Written",
                value: "written",
              },
            ],
          },
        ],
      },
      {
        componentName: "file-upload",
        componentLabel: "Attach a File",
        properties: [
          {
            name: "documentIds",
            label: "Attached Files",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel: "Read Back and Verified",
        properties: [
          {
            name: "readBackAndVerified",
            label: "Verification",
            required: false,
            amendable: false,
          },
        ],
      },
    ],
  },
  {
    orderType: "DME",
    orderTypeDisplayName: "Durable Medical Equipment",
    orderTypeSort: 2,
    amendable: true,
    components: [
      {
        componentName: "text-field",
        componentLabel: "Type of Durable Medical Equipment",
        additionalClasses: "dme-type",
        properties: [
          {
            name: "nameDescription",
            label: "Durable Medical Equipment",
            required: true,
            amendable: true,
          },
        ],
      },
      {
        componentName: "multi-option",
        componentLabel: "Body Systems",
        properties: [
          {
            name: "categories",
            label: "Body Systems",
            required: true,
            amendable: true,
            dropdownItems: [
              {
                label: "Cardiovascular",
                value: "cardiovascular",
              },
              {
                label: "Genitourinary",
                value: "genitourinary",
              },
              {
                label: "Gastrointestinal",
                value: "gastrointestinal",
              },
              {
                label: "Musculoskeletal",
                value: "musculoskeletal",
              },
              {
                label: "Neurological",
                value: "neurological",
              },
              {
                label: "Nutritional & Metabolic",
                value: "nutritionalMetabolic",
              },
              {
                label: "Respiratory",
                value: "respiratory",
              },
              {
                label: "Skin",
                value: "skin",
              },
              {
                label: "Other",
                value: "other",
              },
            ],
          },
        ],
      },
      {
        componentName: "text-field",
        componentLabel: "Issue",
        properties: [
          {
            name: "issue",
            label: "Issue",
            required: false,
            amendable: true,
          },
        ],
      },
      {
        componentName: "date-picker",
        componentLabel: "Order Start Date",
        properties: [
          {
            name: "startDate",
            label: "Order Start Date",
            required: true,
            amendable: true,
            dropdownItems: [
              {
                label: "MM/DD/YYYY",
                value: "MM/DD/YYYY",
                isDefault: true,
              },
            ],
          },
        ],
      },
      {
        componentName: "date-picker",
        componentLabel: "Discontinue Date",
        properties: [
          {
            name: "discontinueDate",
            label: "Discontinue Date",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "MM/DD/YYYY",
                value: "mm/dd/yyy",
                isDefault: true,
              },
            ],
          },
        ],
      },
      {
        componentName: "ordering-provider",
        componentLabel: "Ordering Provider",
        properties: [
          {
            name: "orderingProviderDisplayName",
            label: "Ordering Provider",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Search Provider",
                value: "searchProvider",
                isDefault: true,
              },
            ],
          },
        ],
      },
      {
        componentName: "text-area",
        componentLabel: "Provider Notes",
        properties: [
          {
            name: "providerNotes",
            label: "Provider Notes",
            required: false,
            amendable: true,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
                isDefault: true,
              },
            ],
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel:
          "I, hereby attest this order accurately reflects signatures/notations that I made in my capacity as [ProviderName] when I treated/diagnosed the listed patient. I do hereby electronically attest and certify that this information is true, accurate, and appropriate for this order to the best of my knowledge. ",
        properties: [
          {
            name: "eSignVerification",
            label: "eSignVerification",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "radio-group",
        properties: [
          {
            name: "approvalType",
            label: "Provider Order",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Verbal",
                value: "verbal",
              },
              {
                label: "Written",
                value: "written",
              },
              {
                label: "No Signature Required",
                value: "noSignatureRequired",
              },
            ],
          },
        ],
      },
      {
        componentName: "file-upload",
        componentLabel: "Attach a File",
        properties: [
          {
            name: "documentIds",
            label: "Attached Files",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel: "Read Back and Verified",
        properties: [
          {
            name: "readBackAndVerified",
            label: "Verification",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "text-area",
        componentLabel: "Reason for Amendment",
        properties: [
          {
            name: "reason",
            label: "Reason for Amendment",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    orderType: "LEVEL_OF_CARE",
    orderTypeDisplayName: "Level of Care",
    orderTypeSort: 3,
    amendable: true,
    components: [
      {
        componentName: "level-of-care",
        componentLabel: "Level of Care",
        properties: [
          {
            name: "levelOfCare",
            label: "Level of Care",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Continuous Care",
                value: "continuousCare",
              },
              {
                label: "General In-Patient",
                value: "generalInPatient",
              },
              {
                label: "Respite Care",
                value: "respiteCare",
              },
              {
                label: "Routine Home Care",
                value: "routineHomeCare",
              },
            ],
          },
        ],
      },
      {
        componentName: "multi-option",
        componentLabel: "Symptoms",
        properties: [
          {
            name: "levelOfCareSymptoms",
            label: "Symptoms",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "Agitation",
                value: "agitation",
              },
              {
                label: "Medication Administration",
                value: "medicationAdministration",
              },
              {
                label: "Air-hunger",
                value: "airHunger",
              },
              {
                label: "Nausea",
                value: "nausea",
              },
              {
                label: "Anxiety",
                value: "anxiety",
              },
              {
                label: "Pain",
                value: "pain",
              },
              {
                label: "Bleeding",
                value: "bleeding",
              },
              {
                label: "Respiratory Compromise",
                value: "respiratoryCompromise",
              },
              {
                label: "Dehydration",
                value: "dehydration",
              },
              {
                label: "Restlessness",
                value: "restlessness",
              },
              {
                label: "Diarrhea",
                value: "diarrhea",
              },
              {
                label: "Seizure",
                value: "seizure",
              },
              {
                label: "Dyspnea",
                value: "dyspnea",
              },
              {
                label: "Vital Sign Changes",
                value: "vitalSignChanges",
              },
              {
                label: "Emotional Support",
                value: "emotionalSupport",
              },
              {
                label: "Vomiting",
                value: "vomiting",
              },
              {
                label: "Fever",
                value: "fever",
              },
              {
                label: "Wound Care",
                value: "woundCare",
              },
              {
                label: "Incontinent Care",
                value: "incontinentCare",
              },
              {
                label: "Other",
                value: "other",
              },
            ],
          },
        ],
      },
      {
        componentName: "reason-for-respite",
        componentLabel: "Reason For Respite",
        properties: [
          {
            name: "reasonForRespite",
            label: "Reason For Respite",
            required: false,
            amendable: true,
            dropdownItems: [
              {
                label: "Please Select",
                value: "pleaseSelect",
              },
            ],
          },
        ],
      },
      {
        componentName: "reasons-for-gip",
        componentLabel: "Reason For GIP",
        properties: [
          {
            name: "reasonsForGIP",
            label: "Reason For GIP",
            required: false,
            amendable: true,
            dropdownItems: [
              {
                label: "Pain",
                value: "pain",
                labelDescription:
                  "requires active treatment, intervention, medication changes/additions or frequent assessments.",
              },
              {
                label: "Medication",
                value: "medication",
                labelDescription:
                  "titration/changes/additions warranting frequent evaluations by a nurse or physician.",
              },
              {
                label: "Death is imminent",
                value: "deathIsImminent",
                labelDescription:
                  "as evidenced by clinical deterioration such as apnea, mottling respiratory  changes, changes in Level of Consciousness, requiring frequent nursing care, and/or family is unable to cope with impending death.",
              },
              {
                label: "Family Teaching",
                value: "familyTeaching",
                labelDescription:
                  "of skilled care needs to manage the patient safely and comfortably in home setting.",
              },
              {
                label: "Discharge planning",
                value: "dischargePlanning",
                labelDescription:
                  "continues as the hospice works the family to provide a safe, comfortable transfer to a home setting.",
              },
              {
                label: "Respiratory Distress",
                value: "respiratoryDistress",
                labelDescription:
                  ", compromise, or issues that require frequent assessment, intervention, and/or medication changes/additions.",
              },
              {
                label: "Gastrointestinal Symptoms",
                value: "gastrointestinalSymptoms",
                labelDescription:
                  "that continue to require frequency assessment, intervention, and/or medication changes/additions.",
              },
              {
                label: "Mental Status Changes",
                value: "mentalStatusChanges",
                labelDescription:
                  "that requires frequent assessment, interventions, and/or medication changes/additions.",
              },
              {
                label: "Sudden Significant General Deterioration",
                value: "suddenSignificantGeneralDeterioration",
                labelDescription:
                  "related to the terminal illness requiring intensive nursing intervention.",
              },
              {
                label: "Other",
                value: "other",
              },
            ],
          },
          {
            name: "reasonsForGIPOther",
            label: "Reason For GIP Other",
            required: false,
            amendable: true,
          },
        ],
      },
      {
        componentName: "care-location-type",
        componentLabel: "Care Location Type",
        properties: [
          {
            name: "careLocationType",
            label: "Care Location Type",
            required: true,
            amendable: true,
            dropdownItems: [
              {
                label: "Q5001 - Home",
                value: "home",
                filterValues: ["continuousCare", "routineHomeCare"],
              },
              {
                label: "Q5002 - Assisted Living Facility",
                value: "8",
                filterValues: ["continuousCare", "routineHomeCare"],
              },
              {
                label:
                  "Q5003 - Long-Term Care or Non-Skilled Nursing Facility (Unskilled Care)",
                value: "2",
                filterValues: [
                  "continuousCare",
                  "routineHomeCare",
                  "respiteCare",
                ],
              },
              {
                label: "Q5004 - Skilled Nursing Facility (Skilled Care)",
                value: "7",
                filterValues: [
                  "routineHomeCare",
                  "respiteCare",
                  "generalInPatient",
                ],
              },
              {
                label: "Q5005 - Inpatient Hospital",
                value: "6",
                filterValues: [
                  "routineHomeCare",
                  "respiteCare",
                  "generalInPatient",
                ],
              },
              {
                label: "Q5006 - Inpatient Hospice Facility",
                value: "5",
                filterValues: [
                  "routineHomeCare",
                  "respiteCare",
                  "generalInPatient",
                ],
              },
              {
                label: "Q5007 - Long-Term Care Hospital",
                value: "9",
                filterValues: [
                  "routineHomeCare",
                  "respiteCare",
                  "generalInPatient",
                ],
              },
              {
                label: "Q5008 - Inpatient Psychiatric Facility",
                value: "11",
                filterValues: [
                  "routineHomeCare",
                  "respiteCare",
                  "generalInPatient",
                ],
              },
              {
                label: "Q5009 - Place not otherwise specified",
                value: "10",
                filterValues: [
                  "continuousCare",
                  "routineHomeCare",
                  "respiteCare",
                  "generalInPatient",
                ],
              },
              {
                label: "Q5010 - Hospice Residential Facility",
                value: "12",
                filterValues: [
                  "continuousCare",
                  "routineHomeCare",
                  "respiteCare",
                ],
              },
            ],
          },
        ],
      },
      {
        componentName: "care-location",
        componentLabel: "Care Location",
        properties: [
          {
            name: "careLocation",
            label: "Care Location",
            required: true,
            amendable: true,
          },
          {
            name: "careLocationId",
            label: "Care Location Id",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "patient-location",
        componentLabel: "Patient Location",
        properties: [
          {
            name: "patientLocation",
            label: "Patient Location",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Phone Number",
                value: "--",
              },
              {
                label: "Fax Number",
                value: "--",
              },
              {
                label: "Email Address",
                value: "--",
              },
              {
                label: "Address",
                value: "--",
              },
            ],
          },
        ],
      },
      {
        componentName: "date-picker",
        componentLabel: "Order Start Date",
        properties: [
          {
            name: "startDate",
            label: "Order Start Date",
            required: true,
            amendable: true,
            dropdownItems: [
              {
                label: "MM/DD/YYYY",
                value: "MM/DD/YYYY",
              },
            ],
          },
        ],
      },
      {
        componentName: "ordering-provider",
        componentLabel: "Ordering Provider",
        properties: [
          {
            name: "orderingProviderDisplayName",
            label: "Ordering Provider",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Search Provider",
                value: "searchProvider",
              },
            ],
          },
        ],
      },
      {
        componentName: "text-area",
        componentLabel: "Provider Notes",
        properties: [
          {
            name: "providerNotes",
            label: "Provider Notes",
            required: false,
            amendable: true,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
                isDefault: true,
              },
            ],
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel:
          "I, hereby attest this order accurately reflects signatures/notations that I made in my capacity as [ProviderName] when I treated/diagnosed the listed patient. I do hereby electronically attest and certify that this information is true, accurate, and appropriate for this order to the best of my knowledge. ",
        properties: [
          {
            name: "eSignVerification",
            label: "eSignVerification",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "radio-group",
        properties: [
          {
            name: "approvalType",
            label: "Provider Order",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Verbal",
                value: "verbal",
              },
              {
                label: "Written",
                value: "written",
              },
            ],
          },
        ],
      },
      {
        componentName: "file-upload",
        componentLabel: "Attach a File",
        properties: [
          {
            name: "documentIds",
            label: "Attached Files",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel: "Read Back and Verified",
        properties: [
          {
            name: "readBackAndVerified",
            label: "Verification",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "text-area",
        componentLabel: "Reason for Amendment",
        properties: [
          {
            name: "reason",
            label: "Reason for Amendment",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    orderType: "MEDICATION",
    orderTypeDisplayName: "Medication",
    orderTypeSort: 4,
    amendable: true,
    components: [
      {
        componentName: "checkbox",
        componentLabel: "Compound/Free Text Medication",
        properties: [
          {
            name: "isCompound",
            label: "Compund/Free Text Medication",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "medication-name-description-scriptsure",
        componentLabel: "Name",
        properties: [
          {
            name: "nameDescription",
            label: "Medication Name",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
              },
            ],
          },
        ],
      },
      {
        componentName: "medication-ingredients-scriptsure",
        componentLabel: "Ingredients",
        properties: [
          {
            name: "ingredients",
            label: "Ingredients",
            required: false,
            amendable: true,
            dropdownItems: [{}],
          },
        ],
      },
      {
        componentName: "text-field",
        componentLabel: "Route",
        properties: [
          {
            name: "dosageRoute",
            label: "Route",
            required: true,
            amendable: true,
            dropdownItems: [
              {
                label: "Please Select",
                value: "pleaseSelect",
              },
            ],
          },
        ],
      },
      {
        componentName: "medication-strength-selector-scriptsure",
        componentLabel: "Strength",
        properties: [
          {
            name: "dosageDosage",
            label: "Dosage",
            required: true,
            amendable: true,
          },
          {
            name: "dosageFrequency",
            label: "Frequency",
            required: true,
            amendable: true,
          },
        ],
      },
      {
        componentName: "text-field",
        componentLabel: "Symptoms",
        properties: [
          {
            name: "symptoms",
            label: "Symptoms",
            required: false,
            amendable: true,
            dropdownItems: [
              {
                label: "Please Select",
                value: "pleaseSelect",
              },
            ],
          },
        ],
      },
      {
        componentName: "text-area",
        componentLabel: "Notes",
        properties: [
          {
            name: "orderNotes",
            label: "Order Notes",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
              },
            ],
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel: "Controlled Substance",
        properties: [
          {
            name: "isControlledSubstance",
            label: "Is Controlled Substance",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "multi-option",
        componentLabel: "Body Systems",
        properties: [
          {
            name: "categories",
            label: "Body Systems",
            required: false,
            amendable: true,
            dropdownItems: [
              {
                label: "Cardiovascular",
                value: "cardiovascular",
              },
              {
                label: "Gastrointestinal",
                value: "gastrointestinal",
              },
              {
                label: "Genitourinary",
                value: "genitourinary",
              },
              {
                label: "Musculoskeletal",
                value: "musculoskeletal",
              },
              {
                label: "Neurological",
                value: "neurological",
              },
              {
                label: "Nutritional & Metabolic",
                value: "nutritionalMetabolic",
              },
              {
                label: "Respiratory",
                value: "respiratory",
              },
              {
                label: "Skin",
                value: "skin",
              },
              {
                label: "Other",
                value: "other",
              },
            ],
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel: "Medication Administration Record (MAR)",
        properties: [
          {
            name: "MAR",
            label: "MAR",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "radio-group",
        componentLabel: "Hospice Pays",
        properties: [
          {
            name: "hospicePays",
            label: "Hospice Pays",
            required: false,
            amendable: true,
            dropdownItems: [
              {
                label: "Yes",
                value: "true",
              },
              {
                label: "No",
                value: "false",
              },
            ],
          },
        ],
      },
      {
        componentName: "date-picker",
        componentLabel: "Order Start Date",
        properties: [
          {
            name: "startDate",
            label: "Order Start Date",
            required: true,
            amendable: true,
            dropdownItems: [
              {
                label: "MM/DD/YYYY",
                value: "MM/DD/YYYY",
              },
            ],
          },
        ],
      },
      {
        componentName: "date-picker",
        componentLabel: "Discontinue Date",
        properties: [
          {
            name: "discontinueDate",
            label: "Discontinue Date",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "MM/DD/YYYY",
                value: "mm/dd/yyy",
              },
            ],
          },
        ],
      },
      {
        componentName: "ordering-provider",
        componentLabel: "Ordering Provider",
        properties: [
          {
            name: "orderingProviderDisplayName",
            label: "Ordering Provider",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Search Provider",
                value: "searchProvider",
              },
            ],
          },
        ],
      },
      {
        componentName: "text-area",
        componentLabel: "Provider Notes",
        properties: [
          {
            name: "providerNotes",
            label: "Provider Notes",
            required: false,
            amendable: true,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
              },
            ],
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel:
          "I, hereby attest this order accurately reflects signatures/notations that I made in my capacity as [ProviderName] when I treated/diagnosed the listed patient. I do hereby electronically attest and certify that this information is true, accurate, and appropriate for this order to the best of my knowledge. ",
        properties: [
          {
            name: "eSignVerification",
            label: "eSignVerification",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "radio-group",
        properties: [
          {
            name: "approvalType",
            label: "Provider Order",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Verbal",
                value: "verbal",
              },
              {
                label: "Written",
                value: "written",
              },
            ],
          },
        ],
      },
      {
        componentName: "file-upload",
        componentLabel: "Attach a File",
        properties: [
          {
            name: "documentIds",
            label: "Attached Files",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel: "Read Back and Verified",
        properties: [
          {
            name: "readBackAndVerified",
            label: "Verification",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "text-area",
        componentLabel: "Reason for Amendment",
        properties: [
          {
            name: "reason",
            label: "Reason for Amendment",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    orderType: "OTHER",
    orderTypeDisplayName: "Other",
    orderTypeSort: 5,
    amendable: true,
    components: [
      {
        componentName: "text-field",
        componentLabel: "Type of Order",
        properties: [
          {
            name: "nameDescription",
            label: "Type of Order",
            required: true,
            amendable: false,
          },
        ],
      },
      {
        componentName: "date-picker",
        componentLabel: "Order Start Date",
        properties: [
          {
            name: "startDate",
            label: "Order Start Date",
            required: true,
            amendable: true,
            dropdownItems: [
              {
                label: "MM/DD/YYYY",
                value: "mm/dd/yyy",
              },
            ],
          },
        ],
      },
      {
        componentName: "date-picker",
        componentLabel: "Discontinue Date",
        properties: [
          {
            name: "discontinueDate",
            label: "Discontinue Date",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "MM/DD/YYYY",
                value: "mm/dd/yyy",
              },
            ],
          },
        ],
      },
      {
        componentName: "ordering-provider",
        componentLabel: "Ordering Provider",
        properties: [
          {
            name: "orderingProviderDisplayName",
            label: "Ordering Provider",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Search Provider",
                value: "searchProvider",
              },
            ],
          },
        ],
      },
      {
        componentName: "text-area",
        componentLabel: "Provider Notes",
        properties: [
          {
            name: "providerNotes",
            label: "Provider Notes",
            required: false,
            amendable: true,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
              },
            ],
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel:
          "I, hereby attest this order accurately reflects signatures/notations that I made in my capacity as [ProviderName] when I treated/diagnosed the listed patient. I do hereby electronically attest and certify that this information is true, accurate, and appropriate for this order to the best of my knowledge. ",
        properties: [
          {
            name: "eSignVerification",
            label: "eSignVerification",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "radio-group",
        properties: [
          {
            name: "approvalType",
            label: "Provider Order",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Verbal",
                value: "verbal",
              },
              {
                label: "Written",
                value: "written",
              },
              {
                label: "No Signature Required",
                value: "noSignatureRequired",
              },
            ],
          },
        ],
      },
      {
        componentName: "file-upload",
        componentLabel: "Attach a File",
        properties: [
          {
            name: "documentIds",
            label: "Attached Files",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel: "Read Back and Verified",
        properties: [
          {
            name: "readBackAndVerified",
            label: "Verification",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "text-area",
        componentLabel: "Reason for Amendment",
        properties: [
          {
            name: "reason",
            label: "Reason for Amendment",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    orderType: "SUPPLIES",
    orderTypeDisplayName: "Supplies",
    orderTypeSort: 8,
    amendable: true,
    components: [
      {
        componentName: "text-field",
        componentLabel: "Type of Supplies",
        properties: [
          {
            name: "nameDescription",
            label: "Type of Supplies",
            required: true,
            amendable: false,
          },
        ],
      },
      {
        componentName: "date-picker",
        componentLabel: "Order Start Date",
        properties: [
          {
            name: "startDate",
            label: "Order Start Date",
            required: true,
            amendable: true,
            dropdownItems: [
              {
                label: "MM/DD/YYYY",
                value: "mm/dd/yyy",
              },
            ],
          },
        ],
      },
      {
        componentName: "date-picker",
        componentLabel: "Discontinue Date",
        properties: [
          {
            name: "discontinueDate",
            label: "Discontinue Date",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "MM/DD/YYYY",
                value: "mm/dd/yyy",
              },
            ],
          },
        ],
      },
      {
        componentName: "ordering-provider",
        componentLabel: "Ordering Provider",
        properties: [
          {
            name: "orderingProviderDisplayName",
            label: "Ordering Provider",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Search Provider",
                value: "searchProvider",
              },
            ],
          },
        ],
      },
      {
        componentName: "text-area",
        componentLabel: "Provider Notes",
        properties: [
          {
            name: "providerNotes",
            label: "Provider Notes",
            required: false,
            amendable: true,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
              },
            ],
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel:
          "I, hereby attest this order accurately reflects signatures/notations that I made in my capacity as [ProviderName] when I treated/diagnosed the listed patient. I do hereby electronically attest and certify that this information is true, accurate, and appropriate for this order to the best of my knowledge. ",
        properties: [
          {
            name: "eSignVerification",
            label: "eSignVerification",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "radio-group",
        properties: [
          {
            name: "approvalType",
            label: "Provider Order",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Verbal",
                value: "verbal",
              },
              {
                label: "Written",
                value: "written",
              },
              {
                label: "No Signature Required",
                value: "noSignatureRequired",
              },
            ],
          },
        ],
      },
      {
        componentName: "file-upload",
        componentLabel: "Attach a File",
        properties: [
          {
            name: "documentIds",
            label: "Attached Files",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel: "Read back and Verified",
        properties: [
          {
            name: "readBackAndVerified",
            label: "Verification",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "text-area",
        componentLabel: "Reason for Amendment",
        properties: [
          {
            name: "reason",
            label: "Reason for Amendment",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    orderType: "TREATMENT",
    orderTypeDisplayName: "Treatment",
    orderTypeSort: 6,
    amendable: true,
    components: [
      {
        componentName: "text-field",
        componentLabel: "Type of Treatment",
        properties: [
          {
            name: "nameDescription",
            label: "Type of Treatment",
            required: true,
            amendable: false,
          },
        ],
      },
      {
        componentName: "date-picker",
        componentLabel: "Order Start Date",
        properties: [
          {
            name: "startDate",
            label: "Order Start Date",
            required: true,
            amendable: true,
            dropdownItems: [
              {
                label: "MM/DD/YYYY",
                value: "mm/dd/yyy",
              },
            ],
          },
        ],
      },
      {
        componentName: "date-picker",
        componentLabel: "Discontinue Date",
        properties: [
          {
            name: "discontinueDate",
            label: "Discontinue Date",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "MM/DD/YYYY",
                value: "mm/dd/yyy",
              },
            ],
          },
        ],
      },
      {
        componentName: "ordering-provider",
        componentLabel: "Ordering Provider",
        properties: [
          {
            name: "orderingProviderDisplayName",
            label: "Ordering Provider",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Search Provider",
                value: "searchProvider",
              },
            ],
          },
        ],
      },
      {
        componentName: "text-area",
        componentLabel: "Provider Notes",
        properties: [
          {
            name: "providerNotes",
            label: "Provider Notes",
            required: false,
            amendable: true,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
              },
            ],
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel:
          "I, hereby attest this order accurately reflects signatures/notations that I made in my capacity as [ProviderName] when I treated/diagnosed the listed patient. I do hereby electronically attest and certify that this information is true, accurate, and appropriate for this order to the best of my knowledge. ",
        properties: [
          {
            name: "eSignVerification",
            label: "eSignVerification",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "radio-group",
        properties: [
          {
            name: "approvalType",
            label: "Provider Order",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Verbal",
                value: "verbal",
              },
              {
                label: "Written",
                value: "written",
              },
              {
                label: "No Signature Required",
                value: "noSignatureRequired",
              },
            ],
          },
        ],
      },
      {
        componentName: "file-upload",
        componentLabel: "Attach a File",
        properties: [
          {
            name: "documentIds",
            label: "Attached Files",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel: "Read back and Verified",
        properties: [
          {
            name: "readBackAndVerified",
            label: "Verification",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "text-area",
        componentLabel: "Reason for Amendment",
        properties: [
          {
            name: "reason",
            label: "Reason for Amendment",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    orderType: "VISIT_FREQUENCY",
    orderTypeDisplayName: "Visit Frequency",
    orderTypeSort: 7,
    amendable: true,
    components: [
      {
        componentName: "dropdown",
        componentLabel: "Discipline",
        properties: [
          {
            name: "discipline",
            label: "Discipline",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Hospice Aide",
                value: "Hospice Aide",
              },
              {
                label: "Skilled Nurse",
                value: "Skilled Nurse",
              },
              {
                label: "Social Worker",
                value: "Social Worker",
              },
              {
                label: "Spiritual Advisor",
                value: "Spiritual Advisor",
              },
            ],
          },
        ],
      },
      {
        componentName: "dropdown",
        componentLabel: "Visit(s)",
        properties: [
          {
            name: "visits",
            label: "Visit(s)",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "1 Time",
                value: "1",
              },
              {
                label: "2 Times",
                value: "2",
              },
              {
                label: "3 Times",
                value: "3",
              },
              {
                label: "4 Times",
                value: "4",
              },
              {
                label: "5 Times",
                value: "5",
              },
            ],
          },
        ],
      },
      {
        componentName: "dropdown",
        componentLabel: "Time Interval",
        properties: [
          {
            name: "timeInterval",
            label: "Time Interval",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "Day",
                value: "DAY",
              },
              {
                label: "Week",
                value: "WEEK",
              },
              {
                label: "Month",
                value: "MONTH",
              },
            ],
          },
        ],
      },
      {
        componentName: "dropdown",
        componentLabel: "Duration",
        properties: [
          {
            name: "duration",
            label: "Duration",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "1",
                value: "1",
              },
              {
                label: "2",
                value: "2",
              },
              {
                label: "3",
                value: "3",
              },
              {
                label: "4",
                value: "4",
              },
              {
                label: "5",
                value: "5",
              },
              {
                label: "6",
                value: "6",
              },
              {
                label: "7",
                value: "7",
              },
              {
                label: "8",
                value: "8",
              },
              {
                label: "9",
                value: "9",
              },
              {
                label: "10",
                value: "10",
              },
              {
                label: "11",
                value: "11",
              },
              {
                label: "12",
                value: "12",
              },
              {
                label: "13",
                value: "13",
              },
              {
                label: "14",
                value: "14",
              },
            ],
          },
        ],
      },
      {
        componentName: "date-picker",
        componentLabel: "Order Start Date",
        properties: [
          {
            name: "startDate",
            label: "Order Start Date",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "MM/DD/YYYY",
                value: "MM/DD/YYYY",
              },
            ],
          },
        ],
      },
      {
        componentName: "date-picker",
        componentLabel: "Discontinue Date",
        properties: [
          {
            name: "discontinueDate",
            label: "Discontinue Date",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "MM/DD/YYYY",
                value: "mm/dd/yyy",
              },
            ],
          },
        ],
      },
      {
        componentName: "ordering-provider",
        componentLabel: "Ordering Provider",
        properties: [
          {
            name: "orderingProviderDisplayName",
            label: "Ordering Provider",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Search Provider",
                value: "searchProvider",
              },
            ],
          },
        ],
      },
      {
        componentName: "text-area",
        componentLabel: "Provider Notes",
        properties: [
          {
            name: "providerNotes",
            label: "Provider Notes",
            required: false,
            amendable: false,
            dropdownItems: [
              {
                label: "Please be specific",
                value: "pleaseBeSpecific",
              },
            ],
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel:
          "I, hereby attest this order accurately reflects signatures/notations that I made in my capacity as [ProviderName] when I treated/diagnosed the listed patient. I do hereby electronically attest and certify that this information is true, accurate, and appropriate for this order to the best of my knowledge. ",
        properties: [
          {
            name: "eSignVerification",
            label: "eSignVerification",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "radio-group",
        properties: [
          {
            name: "approvalType",
            label: "Provider Order",
            required: true,
            amendable: false,
            dropdownItems: [
              {
                label: "Verbal",
                value: "verbal",
              },
              {
                label: "Written",
                value: "written",
              },
              {
                label: "No Signature Required",
                value: "noSignatureRequired",
              },
            ],
          },
        ],
      },
      {
        componentName: "file-upload",
        componentLabel: "Attach a File",
        properties: [
          {
            name: "documentIds",
            label: "Attached Files",
            required: false,
            amendable: false,
          },
        ],
      },
      {
        componentName: "checkbox",
        componentLabel: "Read Back and Verified",
        properties: [
          {
            name: "readBackAndVerified",
            label: "Verification",
            required: false,
            amendable: false,
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/providers/order-management-data-service/mock-config.ts